















































import { Component, Prop } from "vue-property-decorator";
import Modal from "@/shared/components/modal.vue";
import { required, validDate, validHora } from "@/shared/validators";
import ComboNovoAtendimento from "../ComboNovoAtendimento.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import DatePicker from "@/shared/components/date-picker.vue";
import {
  ConsultoresService,
  IdTipoAtendimento,
  TipoAtendimento,
} from "@/services/consultores.service";

@Component({
  components: {
    Modal,
    ComboNovoAtendimento,
    DatePicker,
  },
})
export default class NovoAtendimento extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  tipo: number | null = null;
  descricao: string | null = "";
  data: string | null = "";
  hora: string | null = "";

  tipoAtendimento: TipoAtendimento = {
    descricao: "",
    idTipoAtendimento: IdTipoAtendimento["SuporteSistema"],
  };

  rules = {
    descricao: [required()],
    data: [validDate()],
    hora: [validHora()],
  };

  get tituloManter(): string {
    return "Atendimento";
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async novoAtendimento() {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async salvarAtendimento() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.startLoader();
      this.setTipoAtendimento(this.tipo!);
      await ConsultoresService.NovoAtendimento(
        this.idConsultor,
        this.tipoAtendimento,
        this.descricao!,
        this.data!,
        this.hora!
      ).finally(this.stopLoader);
      return modal.close(true);
    }
  }

  setTipoAtendimento(status: number) {
    switch (status) {
      case 1:
        this.tipoAtendimento.idTipoAtendimento =
          IdTipoAtendimento["SuporteSistema"];
        break;
      case 2:
        this.tipoAtendimento.idTipoAtendimento =
          IdTipoAtendimento["Treinamento"];
        break;
      case 3:
        this.tipoAtendimento.idTipoAtendimento =
          IdTipoAtendimento["PossivelCliente"];
        break;
      case 4:
        this.tipoAtendimento.idTipoAtendimento =
          IdTipoAtendimento["PlanoExpirado"];
        break;
      case 5:
        this.tipoAtendimento.idTipoAtendimento =
          IdTipoAtendimento["PlanoGratis10Dias"];
        break;
      case 6:
        this.tipoAtendimento.idTipoAtendimento =
          IdTipoAtendimento["FidelizarCliente"];
        break;
      case 99:
        this.tipoAtendimento.idTipoAtendimento = IdTipoAtendimento["Outros"];
    }
  }
}
